import { Component, ViewChild } from '@angular/core';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexStroke,
  ApexGrid,
  ApexAnnotations,
  ApexLegend,
  ApexMarkers
} from 'ng-apexcharts';
import { Subscription } from 'rxjs';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  annotations: ApexAnnotations;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  labels: string[];
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  colors: string[];
  legend: ApexLegend;
  markers: ApexMarkers;
};

import { TestMonthtlyBusinessService } from './monthly-business-sales.service';

@Component({
  selector: 'pg-monthly-sales-chart',
  templateUrl: './monthy-business-sales-chart.html'
})
export class MonthlyBusinessesSalesComponent {
  annotationSettings: any;
  data: any;
  dataSubscription$: Subscription;
  chartTitle = 'Ventas mensuales de cada local';
  constructor(private testApexService: TestMonthtlyBusinessService) {}

  categories: string[];

  x_title = 'Meses';
  y_title = 'Ventas';

  formatter = (label) => 'S/.' + label;

  ngOnInit() {
    this.dataSubscription$ = this.testApexService
      .getData$()
      .subscribe((statistics) => {
        const { categories, datasets } =
          this.testApexService.getBackendResponseProcessed(statistics);
        this.categories = categories;
        if (this.categories.includes('En')) {
          this.annotationSettings = {
            xaxis: [{ axisLabel: 'En', annoText: 'Año actual' }]
          };
        }

        this.data = datasets;
      });
  }

  ngOnDestroy() {
    this.dataSubscription$.unsubscribe();
  }
}
